import type { RoomError } from '../useRoom';

const FRIENDLY: Record<string, string> = {
  not_host: 'Only the host can do that.',
  not_seated: 'Take a seat first.',
  seat_taken: 'That seat was just taken.',
  nickname_taken: 'That nickname is already at the table.',
  illegal_action: 'That move is not available right now.',
  hand_in_progress: 'Wait for the hand to finish.',
  ended: 'The session has ended.',
};

export function Toasts({ errors, dismiss }: { errors: RoomError[]; dismiss: (id: number) => void }) {
  if (errors.length === 0) return null;
  return (
    <div className="toasts" role="status">
      {errors.map(e => (
        <div key={e.id} className="toast">
          <span>{FRIENDLY[e.code] ?? e.message}</span>
          <button type="button" aria-label="dismiss" onClick={() => dismiss(e.id)}>×</button>
        </div>
      ))}
    </div>
  );
}
